export const ADMIN = 'ADMIN';
export const SELLER = 'SELLER';
export const CUSTOMER = 'CUSTOMER';